import React from 'react';

import { isFinleyAdminDomain } from '../utils';

/**
 * Higher order component that only renders children if on the admin subdomain or in admin dev
 * @param children
 * @constructor
 */
export const AdminOnlyWrapper: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const { host } = window.location;

  if (isFinleyAdminDomain(host)) {
    return <>{children}</>;
  }

  return null;
};
